import { useEffect, useRef } from 'react';
import { isInteractive } from './useSpaceShortcut';

/**
 * `F` opens focus mode while a block or break is on - the key video players
 * taught everyone for "full screen". Same rules as Space: never while typing
 * or with a modifier held. Escape, the way out, belongs to the layer itself.
 */
export function useFocusModeShortcut(
  enabled: boolean,
  onEnter: () => void
): void {
  const latest = useRef(onEnter);
  latest.current = onEnter;

  useEffect(() => {
    if (!enabled) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== 'f' && event.key !== 'F') return;
      if (event.repeat || event.metaKey || event.ctrlKey || event.altKey)
        return;
      if (isInteractive(event.target)) return;
      event.preventDefault();
      latest.current();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [enabled]);
}
